export default __webpack_public_path__ + "static/media/nft-img-example.388a90d2.svg";